let PaymentMethods = {
    ids: {
        TRANSFER: 4,
        CASH: 2,
        CREDIT_CARD: 1,
    },
    text: {
        1: "신용카드",
        2: "현금",
        4: "계좌이체",
    },
    getPaymentMethods: (num) => {
        let ret = [];
        for (let method in PaymentMethods.ids) {
            let id = PaymentMethods.ids[method];
            if (num >= id) {
                ret.push(id);
                num -= id
            }
        }
        return ret;
    },
    getPaymentMethodTexts: (num) =>{
        let ret = [];
        for (let method in PaymentMethods.ids) {
            let id = PaymentMethods.ids[method];
            if (num >= id) {
                ret.push(PaymentMethods.text[id]);
                num -= id
            }
        }
        return ret;

    },
    containsMethod: (num, method) => {
        let methods = PaymentMethods.getPaymentMethods(num);
        return methods.indexOf(method) !== -1;
    }
}
export default PaymentMethods